import React, { Component } from "react";
import enhanceWithClickOutside from "react-click-outside";
import moment from "moment";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import Icon from "../../common/Icon";
import styles from "./ProductMenu.scss";
import sellerimg from "../../../images/core-1.svg";
import intel from "../../../images/intel-1.svg";
import warehouse from "../../../images/warehouse-1.svg";
import grid from "../../../images/menu.svg";

class ProductMenu extends Component {
  state = {
    showProductMenu: false
  };

  // toggling Product menu
  toggleProductMenu = () => {
    this.setState(prevState => ({
      showProductMenu: !prevState.showProductMenu
    }));
  };

  // redirect function to core seller lab
  slRedirect = () => {
    window.location.href = Helper.getSellURL();
  };

  // redirect function to partners intel
  intelRedirect = () => {
    window.location.href = Helper.getIntelURL();
  };

  // redirect function to seller warehouse
  warehouseRedirect = () => {
    window.location.href = Helper.getWarehouseURL();
  };

  handleClickOutside = () => {
    this.setState({ showProductMenu: false });
  };

  render() {
    const { seller } = this.props;
    const { showProductMenu } = this.state;
    return (
      <div className={styles.gridIcon}>
        <div className={styles.gridWrapper} onClick={this.toggleProductMenu}>
          <Icon name="grid" />
        </div>
        {showProductMenu && (
          <div className={styles.wrapper}>
            <div className={styles.header}>
              <span>{I18n.getText("menu.our-app")}</span>
            </div>
            <div className={styles.row}>
              <div
                className={`${styles.imageCtr} ${styles.selected}`}
                onClick={this.slRedirect}
              >
                <img src={sellerimg} alt="seller" />
              </div>
              <div className={styles.imageCtr} onClick={this.intelRedirect}>
                <img src={intel} alt="intel" />
              </div>
              {seller && seller.is_allow_warehouse_app ? (
                <div
                  className={styles.imageCtr}
                  onClick={this.warehouseRedirect}
                >
                  <img src={warehouse} alt="warehouse" />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default enhanceWithClickOutside(ProductMenu);



// WEBPACK FOOTER //
// ./src/components/common/productMenu/ProductMenu.js